import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const deleteImageMapRegionMutation = gql`
  mutation DeleteImageMapRegion($regionId: Int!) {
    region {
      removeRegion(regionId: $regionId, deletePage: true)
    }
  }
`;

const deleteImageMapRegion = ({ regionId, onError, onSuccessResult }) => (
  <Mutation mutation={deleteImageMapRegionMutation}>
    {(deleteImageMapRegionFunc, { loading, error, data }) => {
      const variables = {
        regionId,
      };
      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={deleteImageMapRegionFunc}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

deleteImageMapRegion.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  regionId: PropTypes.number.isRequired,
};

export default deleteImageMapRegion;
